// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyRewardCards_root__dyjGj","text":"EmptyRewardCards_text__a6VQB"};